<template>
  <div class="main">
    <report-top> </report-top>
    <div id="formTable">
      <div id="text">作业线路列表</div>
      <div id="ddas">
        <!-- <Button @click="reOpenWin" type="primary" size="small" icon="md-cloud-download">导出</Button>-->
        <Button @click="openAdd" type="primary" size="small"
          >新增作业线路</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="carClass">
        <clzypb :classes="row.scheduleList"></clzypb>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      :title="isAdd ? '新增作业线路' : '编辑作业线路'"
      footer-hide
      fullscreen
      @on-cancel="cliclCancelBtn"
    >
      <div style="width: 100%; height: 100%; display: flex">
        <div style="width: calc(100% - 700px); height: 100%">
          <xianlu ref="xianlu" v-if="openForm" :lines="linesData"></xianlu>
        </div>
        <div style="width: 700px; height: 100%">
          <div id="dsaecwewe">
            <Row>
              <Col span="24">
                <Form
                  ref="item"
                  :model="item"
                  :rules="ruleValidate"
                  :label-width="80"
                >
                  <Row :gutter="16">
                    <Col span="8">
                      <FormItem label="线路名称" prop="name">
                        <Input v-model="item.name" placeholder="请输入"></Input>
                      </FormItem>
                    </Col>
                    <Col span="8">
                      <FormItem label="项目名称" prop="groupId">
                        <selectItems
                          :name="item.groupName"
                          @update:name="item.groupName = $event"
                          :id="item.groupId"
                          @update:id="item.groupId = $event"
                        ></selectItems>
                      </FormItem>
                    </Col>
                    <Col span="8">
                      <FormItem label="所属部门" prop="deptName">
                        <selectGroup
                          :name="item.deptName"
                          @update:name="item.deptName = $event"
                          :id="item.deptId"
                          @update:id="item.deptId = $event"
                        >
                        </selectGroup>
                      </FormItem>
                    </Col>
                    <Col span="8">
                      <FormItem label="线路等级" prop="grade">
                        <Select v-model="item.grade">
                          <Option
                            v-for="(x, index) in $t('grade')"
                            :value="x"
                            :key="index"
                            >{{ x }}</Option
                          >
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span="8">
                      <FormItem label="线路类型" prop="roadType">
                        <Select v-model="item.roadType">
                          <Option
                            v-for="(x, index) in $t('roadType')"
                            :value="x"
                            :key="index"
                            >{{ x }}</Option
                          >
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span="8" v-if="false">
                      <FormItem label="网格" prop="gridId">
                        <Select v-model="item.gridId">
                          <Option
                            v-for="(x, index) in wanggeList"
                            :value="x.id"
                            :key="index"
                            >{{ x.name }}</Option
                          >
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span="8">
                      <FormItem label="线路" prop="ruleLineIdList">
                        <Select
                          @on-change="getLinesDetail"
                          v-model="item.ruleLineIdList"
                          multiple
                        >
                          <Option
                            v-for="(x, index) in lines"
                            :value="x.id"
                            :key="index"
                            >{{ x.name }}</Option
                          >
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span="24">
                      <FormItem label="工作周期" prop="workWeek">
                        <CheckboxGroup v-model="item.workWeek">
                          <Checkbox
                            v-for="(item, index) in days"
                            :key="index"
                            :label="item.label"
                            >{{ item.name }}</Checkbox
                          >
                        </CheckboxGroup>
                      </FormItem>
                    </Col>
                    <Col span="8">
                      <FormItem label="要求趟数" prop="tripNum">
                        <Input
                          type="number"
                          v-model="item.tripNum"
                          placeholder="请输入"
                        ></Input>
                      </FormItem>
                    </Col>
                    <Col span="8">
                      <FormItem label="每趟次数" prop="tripOne">
                        <Input
                          type="number"
                          v-model="item.tripOne"
                          placeholder="请输入"
                        ></Input>
                      </FormItem>
                    </Col>
                    <Col span="8">
                      <FormItem label="开始点" prop="startP">
                        <select-point
                          :name="item.startP"
                          @update:name="item.startP = $event"
                          :id="item.startPId"
                          @update:id="item.startPId = $event"
                        ></select-point>
                      </FormItem>
                    </Col>
                    <Col span="8">
                      <FormItem label="结束点" prop="endP">
                        <select-point
                          :name="item.endP"
                          @update:name="item.endP = $event"
                          :id="item.endPId"
                          @update:id="item.endPId = $event"
                        ></select-point>
                      </FormItem>
                    </Col>
                    <Col span="8">
                      <FormItem label="作业半径" prop="radius">
                        <Input
                          v-model="item.radius"
                          placeholder="请输入"
                        ></Input>
                      </FormItem>
                    </Col>
                    <Col span="8">
                      <FormItem label="应作业里程" prop="length">
                        <template slot="label">
                          <Tooltip content="单位，公里" placement="top-start"
                            >应作业里程</Tooltip
                          >
                        </template>
                        <Input
                          v-model="item.length"
                          placeholder="请输入"
                        ></Input>
                      </FormItem>
                    </Col>
                  </Row>
                </Form>
              </Col>
              <Col span="24">
                <paibanTool
                  ref="paibanTool"
                  @close="
                    openForm = false;
                    getList();
                  "
                ></paibanTool>
              </Col>
            </Row>
            <div class="clearfloat">
              <div style="float: right">
                <Button>重置表单</Button>
                <Button type="primary" @click="addUpdate('item')"
                  >提交表单</Button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import xianlu from "../map/lyMap.vue";
import paibanTool from "./paibanTool.vue";
import clzypb from "./clzypb.vue";
export default {
  components: { xianlu, paibanTool, clzypb },
  data() {
    return {
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "线路名称",
          key: "name",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "车辆排班",
          slot: "carClass",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "项目名称",
          key: "groupName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "所属部门",
          key: "deptName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "线路类型",
          key: "roadType",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "应作业里程",
          key: "length",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "开始点",
          key: "startP",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "结束点",
          key: "endP",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "要求趟数",
          key: "tripNum",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "每趟次数",
          key: "tripOne",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建者账号",
          key: "createAccount",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        groupId: "",
        deptId: "",
        deptName: "",
        gridId: "",
        name: "",
        startP: "",
        startPId: "",
        endP: "",
        endPId: "",
        tripNum: 1,
        tripOne: 1,
        grade: "一级",
        roadType: "单向车道",
        radius: 10,
        length: 0,
        remark: null,
        pointList: [],
        pointType: 2,
        ruleLineIdList: [],
      },
      ruleValidate: {
        name: { required: true, message: "必填" },
        groupId: { required: true, message: "必填" },
        deptName: { required: true, message: "必填" },
        tripNum: { required: true, message: "必填" },
        tripOne: { required: true, message: "必填" },
        startP: { required: true, message: "必填" },
        endP: { required: true, message: "必填" },
        radius: { required: true, message: "必填" },
        length: { required: true, message: "必填" },
        ruleLineIdList: { required: true, message: "必填" },
        gridId: { required: true, message: "必填" },
      },
      pageNumber: 1,
      pageSize: 50,
      total: 0,
      wanggeList: [],
      lines: [],
      linesData: [],
      days: [
        { label: 0, name: "周日" },
        { label: 1, name: "周一" },
        { label: 2, name: "周二" },
        { label: 3, name: "周三" },
        { label: 4, name: "周四" },
        { label: 5, name: "周五" },
        { label: 6, name: "周六" },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.mwm + "/line/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          if (this.utils.isEmpty(data[i].workWeek)) {
            data[i].workWeek = [];
          }
        }

        this.tableData = data;
      });
    },
    addUpdate(name) {
      console.log(this.item);

      this.$refs[name].validate((valid) => {
        var ddd = this.$refs.paibanTool.watchClass();
        if (!ddd) {
          this.$Message.error("排班信息未填写");
          return;
        }
        if (valid) {
          if (this.isAdd) {
            axios({
              method: "post",
              url: axios.mwm + "/line/add",
              data: this.item,
            }).then((res) => {
              if (res) {
                var lineId = res.data.data;
                this.$refs.paibanTool.reData(lineId);
              }
            });
          } else {
            axios({
              method: "post",
              url: axios.mwm + "/line/update",
              data: this.item,
            }).then((res) => {
              if (res) {
                console.log(res);
                var lineId = res.data.data;
                this.$refs.paibanTool.reData(lineId);
              }
            });
          }
        }
      });
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.mwm + "/line/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      console.log(row);
      this.openForm = true;
      this.isAdd = false;
      this.item = row;
      this.$refs.paibanTool.getList(this.item.id);
      setTimeout(() => {}, 500);
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      this.$refs.xianlu.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.getList();
    },
    getWange() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.swm + "/grid/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        this.wanggeList = data;
      });
    },
    getLineS() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.rule + "/route/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        this.lines = data;
        console.log(data);
      });
    },
    getLinesDetail(v) {
      this.item.length = 0;
      if (v.length == 0) {
        this.linesData = [];
        return;
      }
      var aa = [];

      for (let i = 0; i < v.length; i++) {
        this.utils.loading(this, "加载中");
        axios({
          method: "post",
          url: axios.rule + "/route/item",
          data: { id: v[i] },
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          var abc = res.data.data;
          this.item.length += abc.length;

          var data = res.data.data.coordList;
          var bbb = {
            pointList: data,
          };
          aa.push(bbb);

          if (i == v.length - 1) {
            this.item.length = (this.item.length / 1000).toFixed(2);
            this.linesData = aa;
          }
        });
      }
    },
    getItem(row, type) {},
  },
  mounted() {
    this.getList();
    this.getWange();
    this.getLineS();
  },
};
</script>
<style>
#dsaecwewe {
  width: 100%;
  background: #fff;
  padding: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/carsys/zyxl.vue